<template>
  <Page :title="title">
    <!-- 顶部筛选栏   输入框  搜索 -->
    <div class="header-titile-all">
      <div class="searchTitle-top-header flex">
        <div class="searchTitle-top">
          <div class="picker-alls" @click="chooseScope">
            {{ queryFlagText }}
            <div class="triangle_border_down"></div>
          </div>
          <div class="flex input-search-flex">
            <input
              type="text"
              placeholder="客户姓名"
              ref="inputText"
              v-model="queryParam.customerName"
              class="search_input"
              @keyup.enter="submitInput(queryParam)"
            />
          </div>
        </div>
        <div class="filtrate-list flex" @click="searchInput(queryParam)">
          <img
            :src="require('@/assets/img/search.png')"
            class="filtrate-img"
            alt=""
          />
        </div>
      </div>
      <!-- 筛选列表区域 -->
      <div class="flex flexJ">
        <div class="filtrate-lists-areaList">
          <div class="date-selector" @click="selectTime(1)">
            <span v-if="queryParam.dateFrom">{{
              queryParam.dateFrom | getDate
            }}</span>
            <span v-else>创建日期</span>
            <img
              :src="require('@/assets/img/uparrow.png')"
              class="uparrow"
              alt=""
              srcset=""
            />
          </div>
          <div class="flex column-center"><span>至</span></div>

          <div class="date-selector" @click="selectTime(1.1)">
            <span v-if="queryParam.dateTo">{{
              queryParam.dateTo | getDate
            }}</span>
            <span v-else>创建日期</span>
            <img
              :src="require('@/assets/img/uparrow.png')"
              class="uparrow"
              alt=""
              srcset=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 滑动区域 -->
    <div class="scroll-view" ref="scrollView">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
        ref="page"
      >
        <!-- 内容版块 -->
        <div
          class="scroll-view-list-item"
          v-for="(item, index) in list"
          v-bind:key="index"
        >
          <div
            class="information-list"
            @click="viewCustomerTraffic(item.trafficId)"
          >
            <div
              class="
                information-list-item
                item-lists
                flex
                justify-content-space-between
              "
            >
              <div>
                <span class="boldFonts item-label">到店时间段:</span>
                <span class="activeFonts"
                  >{{ item.dateFrom | getTime }} -
                  {{ item.dateTo | getTime }}</span
                >
              </div>
              <div class="boldFonts">
                <span v-if="item.status === '0'">草稿</span>
                <span v-if="item.status === '1'">已提交</span>
              </div>
            </div>
            <div class="information-list-item item-lists">
              <span class="boldFonts item-label">客户姓名:</span>
              <span class="activeFonts">{{
                item.customerName ? item.customerName : ""
              }}</span>
            </div>
            <div class="information-list-item item-lists">
              <span class="boldFonts item-label">客户类型:</span>
              <span class="activeFonts">{{
                item.customerType ? item.customerType : ""
              }}</span>
            </div>
            <div class="information-list-item item-lists">
              <span class="boldFonts item-label">是否试机:</span>
              <span class="activeFonts">{{ item.test ? "是" : "否" }}</span>
            </div>
            <div class="information-list-item item-lists">
              <span class="boldFonts item-label">创建日期:</span>
              <span class="activeFonts">{{ item.createdTime || "" }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 定位 -->
    <div :class="hasTrafficCreated ? 'orientation-bottom' : 'orientation-bottom-single'">
      <!-- 主页 -->
      <div class="homePage" @click="home">
        <img
          :src="require('@/assets/img/homePage.png')"
          class="homePageImg"
          alt=""
        />
      </div>
      <!-- 添加 -->

      <div class="add" @click="addCustomerTraffic" v-if="hasTrafficCreated">
        <img :src="require('@/assets/img/add.png')" class="addImg" alt="" />
      </div>
    </div>

    <van-popup v-model="show" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        title=""
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
        value-key="name"
        class="van-picker-li"
      />
    </van-popup>

    <!-- 时间筛选 -->
    <van-popup
      v-model="timeShow"
      position="bottom"
      :overlay="true"
      style="width: 100%"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="timeConfirm"
        @cancel="timeCancel"
        @change="timeChange"
      />
    </van-popup>

    <!-- 分页数据计算 -->
    <div
      class="loaded"
      :style="{ bottom: this.$store.state.show == 2 ? '1.2rem' : '0rem' }"
    >
      已加载 {{ this.list.length }}/{{ totalRow }}
    </div>
  </Page>
</template>

<script>
export default {
  name: "customer-traffic-Page",
  data() {
    return {
      title: "到店客流列表",
      totalRow: 0, // 总条数
      list: [],
      show: false,
      loading: false,
      finished: false,
      hasTrafficCreated: false, // 客户到店流量新增权限
      /**********  查询字段  **********/
      pageNumber: 1,
      pageSize: 10,
      queryParam: {
        customerName: "",
        dateTo: null,
        dateFrom: null,
        showStore: 1,
      },
      queryFlagText: "我的",
      pageListShow: true, //加载判断
      columns: [
        {
          name: "我的",
          id: 0,
        },
        {
          name: "本店",
          id: 1,
        },
      ],
      IdCode: "", // 菜单ID
      Icon: [require("@/assets/Sc.png"), require("@/assets/Sn.png")],
      currentDate: new Date(), // 时间
      timeShow: false,
      timeVal: null, //当前展示的时间选择器,
    };
  },
  filters: {
    getTime: function (value) {
      if (!value) {
        return "";
      }
      let formatValue = value.replaceAll("-", "/");
      return new Date(formatValue).Format("hh:mm");
    },
    getDate: function (value) {
      if (!value) {
        return "";
      }
      let formatValue = value.replaceAll("-", "/");
      return new Date(formatValue).Format("yyyy-MM-dd");
    },
  },
  methods: {
    /**
     *  打开个人信息页接口
     *
     * */
    openUserProfile(userExId) {
      this.$wxuserUtil.openUserProfile(userExId);
    },

    /**
     *   客户筛选
     */
    onConfirm(value, index) {
      console.log("picker", value);
      value.id == 0
        ? (this.queryFlagText = "我的")
        : (this.queryFlagText = "本店");
      this.queryParam.showStore = value.id;
      this.loading = false;
      this.finished = false;
      this.pageNumber = 1;
      this.$refs.scrollView.scrollTop = 0;
      this.getClientlist(this.queryParam);
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },

    chooseScope() {
      this.show = true;
    },
    onLoad() {
      setTimeout(() => {
        if (this.pageListShow == true) {
          this.pageNumber = parseInt(this.pageNumber + 1);
          let data = {
            pageNumber: this.pageNumber,
            ...this.queryParam,
            concat: true, // load时 查询结果附加到当前列表
          };
          this.getClientlist(data);
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, 500);
    },
    /**
     *   新增客户  触发弹框
     */
    addCustomerTraffic() {
      this.$router.push({ path: "/edit-customer-traffic" });
    },
    home() {
      this.$refs.inputText.blur();
      this.$router.push({ path: "/" });
    },
    /**
     *
     *  查询到店信息列表
     *
     **/
    getClientlist(
      params,
      option = {
        salesId: this.$wxuserUtil.getUserId(),
        pageNumber: 1,
        pageSize: this.pageSize,
        showStore: 1,
        concat: false,
      }
    ) {
      this.pageListShow = false;
      let data = { ...option, ...params };
      let Response = this.$api.pageListCustomerTraffic(data);
      let result =
        Response.data.list.map((i) => {
          return {
            dateTo: i.U_ArrivalTime_To,
            dateFrom: i.U_ArrivalTime_From,
            buy: i.U_Buy === "1",
            customerName: i.U_Customer,
            gender: i.U_Gender,
            status: i.U_Status,
            test: i.U_Test === "1",
            trafficId: i.U_TrafficId,
            customerType: i.U_Type,
            visitCnt: i.U_VisitCnt,
            createdTime: i.U_CreatedTime,
          };
        }) || [];
      this.loading = false;
      this.list = data.concat ? this.list.concat(result) : result;
      this.totalRow = Response.data ? Response.data.totalRow : 0;
      this.finished = Response.data.lastPage;
      this.pageListShow = Response.data.pageNumber < Response.data.totalPage;
    },
    /**
     *   客户详情
     **/
    viewCustomerTraffic(ID) {
      if (ID) {
        this.$refs.inputText.blur();
        this.$router.push({
          path: "/view-customer-traffic",
          query: { id: ID },
        });
      }
    },
    /**
     *
     *  输入框回车事件
     *
     **/
    submitInput(val) {
      this.list = [];
      this.pageNumber = 1;
      this.$refs.inputText.blur();
      if (val == "") {
        this.clearInputs();
      } else {
        this.loading = false;
        this.finished = false;
        this.$refs.scrollView.scrollTop = 0;
        this.getClientlist(this.queryParam);
      }
    },
    searchInput(val) {
      this.$refs.inputText.blur();
      this.list = [];
      this.pageNumber = 1;
      if (val == "") {
        this.clearInputs();
        console.log("获取输入框值", val);
      } else {
        this.list = [];
        this.pageNumber = 1;
        this.loading = false;
        this.finished = false;
        this.$refs.scrollView.scrollTop = 0;
        this.getClientlist(this.queryParam);
      }
    },
    clearInputs() {
      /**
       *
       *  清空高级搜索
       *  清空筛选
       *  清空页面值
       *
       **/
      this.pageNumber = 1;
      this.pageSize = 10;
      this.$refs.scrollView.scrollTop = 0;
      this.getClientlist();
    },

    selectTime(val) {
      console.log("时间点击", val);
      if (val) {
        this.timeVal = val;
        this.timeShow = true;
      }
    },
    timeConfirm(value) {
      console.log("时间选择", value);
      if (this.timeVal === 1) {
        this.queryParam.dateFrom = value.Format("yyyy-MM-dd 00:00:00");
      }
      if (this.timeVal === 1.1) {
        this.queryParam.dateTo = value.Format("yyyy-MM-dd 23:59:59");
      }
      this.timeShow = false;
    },
    timeCancel(value) {
      if (this.timeVal === 1) {
        this.queryParam.dateFrom = null;
      }
      if (this.timeVal === 1.1) {
        this.queryParam.dateTo = null;
      }
      this.timeShow = false;
    },
    timeChange() {},
  },
  mounted() {
    // 检查客户到店流量新增权限
    this.hasTrafficCreated = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route, this.$funcKey.TrafficCreated);

    this.$refs.scrollView.style.height =
      localStorage.getItem("height") - 100 + "px";
    this.$wxuserUtil.initWxSdk();
    /**初始化页面数据 */
    this.getClientlist();
  },
  created() {},
  watch: {},
  components: {},
};
</script>
<style lang="less" scoped="true">
.header-titile-all {
  background: #fff;
  overflow: hidden;
  height: 2.5rem;
  position: fixed;
  left: 0rem;
  top: 0rem;
  width: 100%;
  z-index: 1000;
}

.searchTitle-top-header {
  margin: 0.3rem;
  height: 1rem;
  .searchTitle-top {
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    height: 1rem;
    align-items: center;
    background: #f6f6f6;
    width: 92%;

    .input-search-flex {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 70%;
      input {
        flex: 0.9;
      }
    }

    .search_input {
      border: none;
      outline: none;
      background: #f6f6f6;
      padding-left: 0.18rem;
    }
    .picker-alls {
      position: relative;
      flex-direction: row;
      align-items: center;
      height: 1rem;
      line-height: 1rem;
      padding: 0 0.3rem;
      border-right: 1px solid #f0f0f0;
      width: 3rem;
      flex: 1;
      .triangle_border_down {
        width: 0;
        height: 0;
        border-width: 0.1rem 0.1rem 0;
        border-style: solid;
        border-color: #333 transparent transparent; /*灰 透明 透明 */
        margin-left: 0.1rem;
        position: absolute;
        right: 0.3rem;
        top: 0.4rem;
      }
    }
  }
  .filtrate-img {
    width: 0.5rem;
    height: 0.5rem;
  }
  .filtrate-list {
    height: 1rem;
  }
  .filtrate-list {
    width: auto;
    text-align: center;
    align-items: center;
    height: 1rem;
    line-height: 1rem;
    overflow: hidden;
    margin-left: 0.18rem;
  }
}
.filtrate-lists-areaList {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 0 0.3rem;
}

.date-selector {
  width: 4rem;
  background: #f6f6f6;
  height: 0.8rem;
  line-height: 0.8rem;
  padding-left: 0.3rem;
  position: relative;
}

.uparrow {
  position: absolute;
  right: 0.2rem;
  top: 50%;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: -0.15rem;
}

.column-center {
  align-items: center;
}
.scroll-view {
  height: 100%;
  width: 100%;
  background: #f4f4f4;
  overflow-y: auto;
  // margin-bottom: 0rem;
  // margin-top: 2.5rem;
  position: fixed;
  top: 2.6rem;
  left: 0rem;
  .headerImgTop {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 1.5rem;
    .vipImg {
      position: absolute;
      right: 0rem;
      top: 0.8rem;
      width: 0.4rem;
      height: 0.4rem;
    }
  }
  .checkbox-list {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-right: 0.3rem;
  }
  .scroll-view-list-item {
    display: flex;
    flex-direction: row;
    margin: 0.3rem;
    background: #fff;
    padding: 0.3rem;
    position: relative;
  }

  .operation {
    position: absolute;
    right: 0.3rem;
    top: 0.3rem;
    width: 2.2rem;
    height: 0.8rem;
    text-align: center;
    line-height: 0.8rem;
    border: 1px solid #d2d2d2;
    border-radius: 0.8rem;
    color: #646262;
    font-size: 0.3rem;
    font-weight: 600;
  }

  .operation-chat {
    position: absolute;
    right: 0.3rem;
    top: 1.3rem;
    width: 2.2rem;
    height: 0.8rem;
    text-align: center;
    line-height: 0.8rem;
    border: 1px solid #d2d2d2;
    border-radius: 0.8rem;
    color: #646262;
    font-size: 0.3rem;
    font-weight: 600;
  }

  .information-list {
    display: flex;
    flex-direction: column;
    margin-left: 0.3rem;
    width: 4.5rem;
    flex: 1;
  }
  .headerImg {
    width: 1rem;
    height: 1rem;
  }
  .information-list-item {
    text-align: left;
  }
}
.item-lists {
  line-height: 0.5rem;
  align-items: center;
}
.activeFonts {
  color: #979797;
}
.item-label {
  width: 2.2rem;
  display: inline-block;
}

.orientation-bottom {
  position: fixed;
  bottom: 1.5rem;
  right: 0.3rem;
  z-index: 10;
  width: 1rem;
  height: 2.5rem;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.orientation-bottom-single {
  position: fixed;
  bottom: 1.5rem;
  right: 0.3rem;
  z-index: 10;
  width: 1rem;
  height: 1rem;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #000000;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  .homePageImg,
  .addImg {
    width: 0.5rem;
    height: 0.5rem;
  }
  .homePage,
  .add {
    height: 1.25rem;
    line-height: 1.25rem;
    width: 100%;
    align-items: center;
    text-align: center;
  }
  .homePage {
    border-bottom: 1px solid #5e5e5e;
  }
}
.loaded {
  position: fixed;
  bottom: 0rem;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  background: rgba(000, 000, 000, 0.35);
  color: #fff;
  width: 100%;
}
.justify-content-space-between {
  justify-content: space-between;
}
.boldFonts {
  color: #2a2a2a;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/client/customerTraffic.vue